// extracted by mini-css-extract-plugin
export var noSpinners = "_nd-6";
export var percentageInput = "_nd-7";
export var variantColor1 = "_nd-0";
export var variantColor2 = "_nd-1";
export var variantColor3 = "_nd-2";
export var variantColor4 = "_nd-3";
export var variantColor5 = "_nd-4";
export var variantColor6 = "_nd-5";